"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _format = _interopRequireDefault(require("date-fns/format"));
var _constants = require("../constants");
function travellerPayloadFactory(traveller, index) {
  var travellerPayload = {
    index: index + 1,
    title: traveller === null || traveller === void 0 ? void 0 : traveller.title,
    firstName: traveller === null || traveller === void 0 ? void 0 : traveller.firstName,
    middleName: traveller === null || traveller === void 0 ? void 0 : traveller.middleName,
    lastName: traveller === null || traveller === void 0 ? void 0 : traveller.lastName,
    type: traveller === null || traveller === void 0 ? void 0 : traveller.type,
    seatIndex: traveller === null || traveller === void 0 ? void 0 : traveller.seatIndex
  };
  if (traveller !== null && traveller !== void 0 && traveller.isDateOfBirthRequired) {
    travellerPayload.birthDate = (0, _format.default)(traveller === null || traveller === void 0 ? void 0 : traveller.birthDate, _constants.DEFAULT_DATE_FORMAT);
  }
  if (traveller !== null && traveller !== void 0 && traveller.isIDRequired) {
    var _traveller$idType, _traveller$idExpiryDa, _traveller$idNumber, _traveller$nationalit, _traveller$issuingCou;
    travellerPayload.idType = (_traveller$idType = traveller === null || traveller === void 0 ? void 0 : traveller.idType) !== null && _traveller$idType !== void 0 ? _traveller$idType : '';
    travellerPayload.idExpiryDate = (0, _format.default)((_traveller$idExpiryDa = traveller === null || traveller === void 0 ? void 0 : traveller.idExpiryDate) !== null && _traveller$idExpiryDa !== void 0 ? _traveller$idExpiryDa : '', _constants.DEFAULT_DATE_FORMAT);
    travellerPayload.idNumber = (_traveller$idNumber = traveller === null || traveller === void 0 ? void 0 : traveller.idNumber) !== null && _traveller$idNumber !== void 0 ? _traveller$idNumber : '';
    travellerPayload.countryId = (_traveller$nationalit = traveller === null || traveller === void 0 ? void 0 : traveller.nationality) !== null && _traveller$nationalit !== void 0 ? _traveller$nationalit : '';
    travellerPayload.identityCountryId = (_traveller$issuingCou = traveller === null || traveller === void 0 ? void 0 : traveller.issuingCountry) !== null && _traveller$issuingCou !== void 0 ? _traveller$issuingCou : '';
  }
  if (traveller !== null && traveller !== void 0 && traveller.isAPIsRequired) {
    var _traveller$nationalit2;
    travellerPayload.countryId = (_traveller$nationalit2 = traveller === null || traveller === void 0 ? void 0 : traveller.nationality) !== null && _traveller$nationalit2 !== void 0 ? _traveller$nationalit2 : '';
  }
  return travellerPayload;
}
var _default = exports.default = travellerPayloadFactory;